<template>
  <div style="width: 100%;height: 100%;" class="body4" >
    <div class="all">
      <div class="main">
        <div class="wraper" style="width: 100%">
          <div class="clear"></div>
          <div class="policy_con" style="margin-top: 0px;">
            <div class="policy_left">
              <div class="policy_left1" style="display: none;">
                <h2 class="tit tit3">目录导航</h2>
                <p><input  type="text" placeholder="请输入关键词"></p>
              </div>
              <div class="policy_left2">
                <ul>
                  <li>目录导航</li>
                </ul>
                <el-tree :data="treeData" :props="defaultProps" :default-expand-all="true" :highlight-current="true" @node-click="handleNodeClick"></el-tree>
              </div>
            </div>
            <div class="policy_right">
              <div class="policy_right1" style="display: none">
                <h2 class="tit tit4">数据筛选</h2>
                <p>
                  <span>排序: <a href="javascript:void(0)">相关热度</a><a href="javascript:void(0)">按时间</a></span>
                  <span>搜索位置: <a href="javascript:void(0)">全文</a><a href="javascript:void(0)">标题</a></span>
                  <span>日期筛选: <a href="javascript:void(0)">一周内</a><a href="javascript:void(0)">一月内</a><a href="javascript:void(0)">一年内</a><a href="javascript:void(0)">不限</a></span>
                </p>
              </div>
              <div class="policy_right2" style="padding-right: 10%">
                <h2 class="tit tit5">政策文件<div style="float: right;" >
                 <span>发布单位：
          <el-cascader v-model="selectedRegion" :props="props" :show-all-levels="false" placeholder="请选择发布单位" clearable style="width: 250px;"></el-cascader>
                  </span>
                  <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="initData(1)">搜索</el-button></div></h2>
                <ul v-if="listData && listData.length>0">
                  <li  v-for="(item,index) in listData" :key="item.data_id" @click="gotoDetail(item.data_id)">
                    <a  href="javascript:void(0)">
                      <dt style="height: 90px"><h3><img src="../../static/images/policy_sign6.png"></h3><p>{{item.policy_date}}</p></dt>
                      <dd style="height: 90px;padding-top: 10px;">
                        <div style="height: 24px;line-height: 20px;font-size: 12px;border-bottom: 1px solid #d7d6d6;"><span style="font-weight: 600">文号：</span>{{item.policy_number}}&nbsp; &nbsp;<span style="font-weight: 600;margin-left: 50px;">发布单位：</span>{{item.party_name}}</div>
                        <h4 style="margin-top: 10px;">{{item.title}} </h4>
                        <div style="width:100%;height:48px;    color: #888888;line-height:24px;font-size: 12px;overflow:hidden;text-overflow:ellipsis">{{item.policy_abstract}}</div>
                      </dd>
                    </a>
                  </li>
                </ul>
                <ul v-else>
                  <div style="text-align: center;font-size: 14px; color: rgb(155 159 162);">
                    <div><img src="../../static/images/empty-image-default.png" style="width: 300px;" /></div>
                    <div>暂无数据</div>
                  </div>
                </ul>
                <div class="clear"></div>
              </div>
              <div style="text-align: center;height: 50px;line-height: 50px;"> <el-pagination
                layout="prev, pager, next"
                :total="pageTotal" :page-size="pageSize" @current-change="pageChange" @prev-click="prevClick" :hide-on-single-page="true" @next-click="nextClieck">
              </el-pagination>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="clear"></div>
  </div>
</template>

<script>
import headers from "../components/Headers";
import fixedDiv from "../components/FixedDiv";
import footers from "../components/Footer";
export default {
  name: "public-index",
  components:{
    headers,fixedDiv,footers
  },
  data() {
    let _self=this;
    return {
      active: 'publicIndex',
      width:document.body.clientWidth+'px',
      height:document.body.clientHeight+'px',
      props: {
        lazy: true,
        checkStrictly:true,
        lazyLoad (node, resolve) { const { level } = node;
          var t=0;
          if(!node.value){
            node.value=_self.$cookies.get("areaRoot");
            t=1;
            //上级为空，默认设置大通县数据
          }
          const options={pid:node.value}
          _self.$https.post("api/pu/getAreaByParentCode.do",options,response=>{
            const nodes =[];
            // if(t==0) {
              if (response.status === 200 && response.data.code === 200) {
                const nodes = Object.values(response.data.data).map(function (e) {
                  return {label: e.name, value: e.code, level: 0, leaf: level >= 3}
                })
                resolve(nodes);
              } else {
                resolve(nodes);
              }
            // }else{
            //   const nodes =[{label:'大通县',value:'6301210001',level:0, leaf: level >= 2}];
            //   resolve(nodes);
            // }
          })
        }
      },
      treeData:[],
      defaultProps: {
        children: 'children',
        label: 'text'
      },
      listData:[],
      searchTitle:'',
      pageNum:1,
      pageSize:6,
      selectedRegion:[],
      selecteddepartOption:[],
      departOption:[],
      selecteddylbOption:[],
      qry_archive_type:'',
      qry_policy_type:'',
      qry_policy_grade:'',
      pageTotal:0,
    }
  } ,
  watch: {
    width(n,o){
      alert(n+'w')
    },
    height(n,o){
      alert(n+'h')
    },
  // selectedRegion(nv){
  //   this.getDepartAreas(nv[nv.length-1],0);
  // }
  },
  created(){
    this.initRootTree();
    this.initData(1);
  },
  methods: {
    gotoDetail(detail_id){
      this.$router.push({path:'PolicyDetailWeb',query:{detail_id:detail_id}})
    },
    initData(tts){
      if(tts){
        this.pageNum=1;
      }
      var partyId="";
      if(this.selectedRegion && this.selectedRegion.length>0){
        partyId=this.selectedRegion[this.selectedRegion.length-1];
      }
      const options={
        partyId:partyId,
        pageSize:this.pageSize,
        pageNum:this.pageNum,
        searchTitle:this.searchTitle,
        qry_archive_type:this.qry_archive_type,
        qry_policy_type:this.qry_policy_type,
        qry_policy_grade:this.qry_policy_grade
      }
      var t=this;
      this.$https.post("api/policy/getPolicyList.do",options,response=>{
        if (response.status === 200 && response.data.code===200) {
          if(response.data.data.listData && response.data.data.listData.length>0){
            t.listData=response.data.data.listData;
          }else {
            t.listData=[]
          }
          t.pageTotal=response.data.data.total;
        } else {
          // t.departOption =[];
        }
      })
    },
    prevClick(a){
      this.pageNum=this.pageNum-1;
      this.initData();
    },
    nextClieck(a){
      this.pageNum=this.pageNum+1;
      this.initData();
    },
    pageChange(a){
      this.pageNum=a
      this.initData();
    },
    handleNodeClick(data){
      if(data.children && data.children.length>0){
        this.qry_archive_type = '';
        this.qry_policy_type = '';
        this.qry_policy_grade =  '';
        console.log(data);
        return;
      }
      if(data.attributes.type=='qry_archive_type'){
        if(this.qry_archive_type !=data.id){
          this.qry_archive_type=data.id;
          this.qry_policy_type='';
          this.qry_policy_grade='';
          this.initData(1);
          console.log(data);
        }
      }else if(data.attributes.type=='qry_policy_type'){
        if(this.qry_policy_type !=data.id) {
          this.qry_archive_type = '';
          this.qry_policy_type = data.id;
          this.qry_policy_grade = '';
          this.initData(1);
          console.log(data);
        }
      }else if(data.attributes.type=='qry_policy_grade'){
        if(this.qry_policy_grade !=data.id) {
          this.qry_archive_type = '';
          this.qry_policy_type = '';
          this.qry_policy_grade =  data.id;
          this.initData(1);
          console.log(data);
        }
      }else{
        this.qry_archive_type = '';
        this.qry_policy_type = '';
        this.qry_policy_grade =  '';
        this.initData(1);
        console.log(data);
      }
    },
    initRootTree(){
      this.$https.post("api/policy/getQryConditionTreeData.do",{},response=>{
        if (response.status === 200 && response.data.code===200) {
          this.treeData=response.data.data;
        } else {
        }
      })
    },
    getDepartAreas(ParentId,index){
      const options={pid:ParentId}
      var t=this;
      this.$https.post("api/pu/getPartyByParentAreaCode.do",options,response=>{
        if (response.status === 200 && response.data.code===200) {
          t.departOption = Object.values(response.data.data).map(function(e){
            return {label:e.name,value:e.code,leaf:true}
          })
        } else {
          t.departOption =[];
        }
      })
    },
    urlTo(url,params){
      this.$router.push({path:url,query:params||{}});
    }
  }
}



</script>
<style>
  .publicity table td {
    padding: 0px 5px;
  }
  .policy_left2 .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
    background-color: #3f76ea;
    color: white;
  }
  .body4{
      background:#f7f7f7 ;
  }
</style>



// WEBPACK FOOTER //
// src/pages/PolicyServiceWebIndex.vue